<template>
    <div class="customer-admin-management-wrap">
        <ul class="custom-tabbar">
            <li v-for="(tabItem, tabIndex) in tabList" :key="tabIndex" @click="handleClickTab(tabItem.name)" :class="{ active: tabItem.name == activeName }">
                <span>{{ tabItem.label }}</span>
            </li>
        </ul>
        <div class="customer-admin-management-content">
            <template v-if="activeName == 'FormManagement'">
                <FormManagement />
            </template>
            <template v-else>
                <HighSeasManagement />
            </template>
        </div>
    </div>
</template>
<script>
import FormManagement from './form_management.vue';
import HighSeasManagement from './high_seas_management.vue';
export default {
    name: "CustomerSeasAdminManagement",
    components: {FormManagement, HighSeasManagement},
    data() {
        return {
            activeName: "FormManagement",
            tabList: [
                { name: "FormManagement", label: "表单管理" },
                { name: "SeasManagement", label: "公海池管理" }
            ],

        }
    },
    methods: {
        handleClickTab(name) {
            this.activeName = name;
        }
    }
}
</script>
<style lang="scss" scoped>
.customer-admin-management-wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    .custom-tabbar {
        position: relative;
        padding: 0 16px;
        border-bottom: 1px solid #e8e8e8;
        flex-shrink: 0;

        li {
            display: inline-block;
            vertical-align: top;
            height: 48px;
            line-height: 48px;
            padding: 0 16px;
            position: relative;
            font-size: 16px;
            font-weight: 400;
            letter-spacing: 0px;
            color: rgba(102, 102, 102, 1);
            cursor: pointer;

            &.active {
                font-size: 16px;
                font-weight: 700;
                letter-spacing: 0px;
                color: rgba(41, 144, 255, 1);

                &::after {
                    content: "";
                    display: block;
                    position: absolute;
                    left: 0;
                    right: 0;
                    width: 100%;
                    bottom: 0;
                    height: 2px;
                    opacity: 1;
                    background: #2990ff;
                }
            }
        }
    }
    .customer-admin-management-content {
        flex: 1;
    }
}
</style>
